export default {
  hero: {
    badge: 'USFans Spreadsheet Resource Hub',
    title: 'USFans Spreadsheet — Find Products, Sellers & Buying Guides',
    subtitle: 'Explore USFans spreadsheet resources, product links, seller information, reviews, shipping guides, QC tips and practical buying information in one organized place.',
    ctaExplore: 'Explore USFans Spreadsheet',
    ctaBuy: 'Buy It Now',
  },
  category: {
    title: 'Browse Product Categories',
    subtitle: 'Jump straight to any category on the main website with a single click.',
    dropdownLabel: 'Quick category picker',
    dropdownPlaceholder: 'Select a category...',
    visit: 'View category',
    shoes: 'Shoes',
    hoodies: 'Hoodies / Sweaters',
    tshirts: 'T-Shirts',
    jackets: 'Jackets',
    pants: 'Pants / Shorts',
    headwear: 'Headwear',
    sets: 'Sets',
    underwear: 'Underwear / Underpants',
    jersey: 'Jersey',
    accessories: 'Accessories',
    bags: 'Bags',
    belts: 'Belts',
    perfumes: 'Perfumes',
    other: 'Other Stuff',
  },
  cta: {
    title: 'Start With the USFans Spreadsheet',
    text: 'Explore organized USFans resources, reviews, shipping information and practical buying guides. Two quick links take you straight to the main website.',
    spread: 'USFans Spreadsheet',
    buyNow: 'Buy It Now',
  },
  about: {
    title: 'What Is a USFans Spreadsheet?',
    p1: 'A USFans spreadsheet is a structured way to organize product links, seller information, categories and related buying resources in a single, easy-to-read place.',
    p2: 'USFansLink helps users research products, sellers, quality checks, shipping, warehouse information and safety considerations before they place an order. It brings the most useful resources together so you can find what you need faster.',
  },
  resources: {
    title: 'Popular Resources',
    subtitle: 'Quick answers to the questions buyers ask most before ordering.',
    reviews: { title: 'USFans Reviews', text: 'Understand what to check before using a service or seller.' },
    shipping: { title: 'USFans Shipping Cost', text: 'Learn what can affect shipping costs and delivery times.' },
    coupons: { title: 'USFans Coupons', text: 'Learn how to find and verify available coupons and discount codes.' },
    warehouse: { title: 'USFans Warehouse', text: 'Understand warehouse storage, inspection and related processes.' },
    legit: { title: 'Is USFans Legit?', text: 'Learn practical safety checks before purchasing.' },
  },
  guide: {
    title: 'New to USFans? Start Here',
    text: 'Read our complete beginner guide to understand the spreadsheet, what to check before ordering, and how to avoid common mistakes.',
    cta: 'Read the Full Guide',
  },
  pillar: {
    title: 'Pillar Articles & Guides',
    subtitle: 'In-depth guides covering the topics that matter most before you order.',
  },
  faq: {
    title: 'Frequently Asked Questions',
    q1: 'What is a USFans spreadsheet?',
    a1: 'A USFans spreadsheet is an organized catalog of product links, categories, seller details and buying resources. It helps you browse and compare items in one place.',
    q2: 'How do I buy a product I found in the spreadsheet?',
    a2: 'Follow the category link to the main website, find the item you want, and follow the regular checkout process there.',
    q3: 'Is the information in the spreadsheet always up to date?',
    a3: 'USFansLink keeps the structure and links organized, but product availability and prices are managed by the main website. Always double-check the details there before ordering.',
    q4: 'Is USFansLink the same as the main website?',
    a4: 'No. USFansLink is an independent informational resource that helps you explore and understand the spreadsheet. Purchases happen on the main website.',
  },
};